// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.volumeClass {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 40px;\n  line-height: 16px;\n  bottom: 25px;\n  color: #409eff;\n  cursor: pointer;\n}\n.weightVolume .el-dialog__body {\n  padding: 0 !important;\n}\n.copyOrder .el-dialog__header {\n  height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
